import React, { useState } from "react";
import axios from "axios";
import ReCAPTCHA from "react-google-recaptcha";
import toast, { Toaster } from "react-hot-toast";
import * as EmailValidator from "email-validator";
import products from "../constant/products.json";
import career from "../constant/career.json";

const CustomSelect = ({ options, value, onChange, defaultValue, name }) => {
  return (
    <div className="relative inline-block w-full">
      <label>
        <span className="sr-only">Select an option:</span>
        <select
          name={name}
          value={value}
          onChange={onChange}
          className="w-full pt-3 pb-3 bg-white border-b border-gray-500 focus:outline-none text-gray-600 placeholder:text-gray-600 appearance-none"
        >
          <option value="">{defaultValue}</option>
          {options?.map((option, index) => (
            <option key={index} value={option.title || option}>
              {option.title || option}
            </option>
          ))}
        </select>
      </label>
      <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
        <svg
          width="10"
          height="7"
          viewBox="0 0 10 7"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M4.38108 6.23858C4.701 6.58714 5.299 6.58714 5.61892 6.23858L9.81783 1.66367C10.2449 1.19841 9.87339 0.5 9.19891 0.5H0.801092C0.126608 0.5 -0.244851 1.19841 0.182173 1.66367L4.38108 6.23858Z"
            fill="#6C757D"
          />
        </svg>
      </div>
    </div>
  );
};

const FreeQuotesModal = ({ onClose, dropdownName, productName }) => {
  const { interested, budget } = career;
  const [captcha, setCaptcha] = useState(null);
  const [selectedCaptcha, setSelectedCaptcha] = useState(false);

  const [inputs, setInputs] = useState({
    name: "",
    email: "",
    phone: "",
    company_name: "",
    interested: "",
    budget: "",
    product_name: "",
    messages: "",
  });

  const [errors, setErrors] = useState({
    name: "",
    email: "",
    phone: "",
    company_name: "",
    interested: "",
    budget: "",
    messages: "",
  });

  const handleValidation = () => {
    let errorss = {};
    let isValid = false;
    if (!inputs["name"]) {
      errorss["name"] = "Enter your Name";
    } else if (!EmailValidator.validate(inputs["email"])) {
      if (!inputs["email"]) {
        errorss["email"] = "Enter your Email Address";
      } else {
        errorss["email"] = "Please Enter Valid Email Address";
      }
    } else if (inputs.phone.length >= 1 && inputs.phone.length !== 10) {
      errorss["phone"] = "Please enter valid number";
    } else if (!inputs["company_name"]) {
      errorss["company_name"] = "Enter your Company Name";
    } else if (!inputs["interested"]) {
      errorss["interested"] = "Please select your Interest";
    } else if (!inputs["budget"]) {
      errorss["budget"] = "Please select your Budget";
    } else if (!inputs["messages"]) {
      errorss["messages"] = "Enter your message";
    } else {
      isValid = true;
    }
    setErrors(errorss);
    return isValid;
  };

  const handleInputChange = e => {
    const { name, value } = e.target;

    if (name === "phone") {
      const numericValue = value.replace(/[^0-9]/g, "").slice(0, 10);
      setInputs(inputs => ({ ...inputs, [name]: numericValue }));
    } else {
      setInputs(inputs => ({ ...inputs, [name]: value }));
    }
  };

  const verifyCallback = response => {
    if (response) {
      setSelectedCaptcha(true);
    }
  };

  const sendRequest = e => {
    e.preventDefault();
    const valid = handleValidation();
    if (valid && !selectedCaptcha) {
      toast.error("The captcha is missing!");
    }

    if (valid && selectedCaptcha) {
      captcha.reset();
      setSelectedCaptcha(false);

      const myPromise = axios({
        method: "POST",
        url: "https://n8n.infyom.com/webhook/get-free-quotes",
        headers: { "Content-Type": "application/json" },
        data: JSON.stringify(inputs),
      });

      toast.promise(myPromise, {
        loading: "Sending your request...",
        success: "Your message submitted successfully. We will come back to you soon.",
        error: "Something went wrong, Please try again.",
      });

      myPromise
        .then(res => {
          if (res.status === 200) {
            const data = {
              name: "",
              phone: "",
              email: "",
              company_name: "",
              interested: "",
              budget: "",
              product_name: "",
              messages: "",
            };
            setInputs(data);
            onClose();
          }
        })
        .catch(() => {});
    }
  };

  return (
    <div className="fixed inset-0 overflow-auto z-50 bg-black bg-opacity-50 p-4">
      <Toaster position="top-center" />
      <div className="min-h-full h-fit w-full flex items-center justify-center">
        <div className="bg-white relative sm:rounded-[20px] rounded-[15px] w-full  max-w-[960px] md:p-10 sm:p-8 p-6">
          <button
            onClick={onClose}
            className="text-gray-500 hover:text-gray-700 h-fit absolute sm:right-8 xs:right-6 right-4 sm:top-8 xs:top-6 top-4"
          >
            <svg
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M9.46604 8.00012L15.6962 1.76972C16.1017 1.36446 16.1017 0.709208 15.6962 0.303946C15.291 -0.101315 14.6357 -0.101315 14.2305 0.303946L8.00007 6.53434L1.76986 0.303946C1.36441 -0.101315 0.70935 -0.101315 0.304089 0.303946C-0.101363 0.709208 -0.101363 1.36446 0.304089 1.76972L6.5343 8.00012L0.304089 14.2305C-0.101363 14.6358 -0.101363 15.291 0.304089 15.6963C0.506055 15.8984 0.77161 16 1.03698 16C1.30234 16 1.56771 15.8984 1.76986 15.6963L8.00007 9.46589L14.2305 15.6963C14.4326 15.8984 14.698 16 14.9634 16C15.2287 16 15.4941 15.8984 15.6962 15.6963C16.1017 15.291 16.1017 14.6358 15.6962 14.2305L9.46604 8.00012Z"
                fill="#ADB5BD"
              />
            </svg>
          </button>
          <div className="max-w-[620px] text-center mx-auto md:mb-10 mb-7">
            <h2 className="font-bold text-center lg:text-4xl text-3xl mb-5">Get a Free Quote</h2>
            <p className="md:text-lg text-base leading-normal text-gray-700">
              Got a great idea in your mind? Interested in our Products and Services? Submit your
              query here and we will get back to you as soon as possible.
            </p>
          </div>
          <form>
            <div className="sm:grid lg:grid-cols-2 sm:grid-cols-2 lg:gap-x-10 gap-x-8 gap-y-[30px] justify-between">
              <div className="sm:mb-0 mb-4">
                <input
                  type="text"
                  placeholder="Full Name"
                  className="w-full pt-3 pb-3 bg-white border-b border-gray-500 focus:outline-none text-gray-600 placeholder:text-gray-600"
                  value={inputs.name}
                  name="name"
                  onChange={e => handleInputChange(e)}
                />
                <span className="text-red-600">{errors["name"] ? errors["name"] : null}</span>
              </div>
              <div className="sm:mb-0 mb-4">
                <input
                  type="text"
                  placeholder="Email ID"
                  className="w-full pt-3 pb-3 bg-white border-b border-gray-500 focus:outline-none text-gray-600 placeholder:text-gray-600"
                  value={inputs.email}
                  name="email"
                  onChange={e => handleInputChange(e)}
                />
                <span className="text-red-600">{errors["email"] ? errors["email"] : null}</span>
              </div>
              <div className="sm:mb-0 mb-4">
                <input
                  type="text"
                  placeholder="Phone Number"
                  className="w-full pt-3 pb-3 bg-white border-b border-gray-500 focus:outline-none text-gray-600 placeholder:text-gray-600"
                  value={inputs.phone}
                  name="phone"
                  onChange={e => handleInputChange(e)}
                />
                <span className="text-red-600">{errors["phone"] ? errors["phone"] : null}</span>
              </div>
              <div className="sm:mb-0 mb-4">
                <input
                  type="text"
                  placeholder="Company Name"
                  className="w-full pt-3 pb-3 bg-white border-b border-gray-500 focus:outline-none text-gray-600 placeholder:text-gray-600"
                  value={inputs.company_name}
                  name="company_name"
                  onChange={e => handleInputChange(e)}
                />
                <span className="text-red-600">
                  {errors["company_name"] ? errors["company_name"] : null}
                </span>
              </div>
              <div className="sm:mb-0 mb-4">
                <CustomSelect
                  options={interested}
                  defaultValue="Interested In"
                  value={inputs.interested || dropdownName}
                  name="interested"
                  onChange={e => handleInputChange(e)}
                />
                <span className="text-red-600">
                  {errors["interested"] ? errors["interested"] : null}
                </span>
              </div>
              <div className="sm:mb-0 mb-4">
                <CustomSelect
                  options={budget}
                  defaultValue="Select Budget"
                  value={inputs.budget}
                  name="budget"
                  onChange={e => handleInputChange(e)}
                />
                <span className="text-red-600">{errors["budget"] ? errors["budget"] : null}</span>
              </div>
              <div className="sm:mb-0 mb-4">
                <CustomSelect
                  options={products.map(product => ({ title: product.subTitle || product.title }))}
                  defaultValue="Select Product"
                  value={inputs.product || productName}
                  name="product"
                  onChange={e => handleInputChange(e)}
                />
              </div>
              <div className="sm:mb-0 mb-4">
                <textarea
                  id="message"
                  placeholder="Type a Message"
                  className="w-full pt-3 pb-3 bg-white border-b border-gray-500 focus:outline-none text-gray-600 placeholder:text-gray-600"
                  rows="1"
                  value={inputs.message}
                  name="messages"
                  onChange={e => handleInputChange(e)}
                />
                <span className="text-red-600">
                  {errors["messages"] ? errors["messages"] : null}
                </span>
              </div>
            </div>
            <div className="flex justify-center mt-2 modal-recaptcha-scale">
              <ReCAPTCHA
                sitekey={`${process.env.CAPTCHA}`}
                onChange={verifyCallback}
                ref={e => setCaptcha(e)}
              />
            </div>
            <div className="flex mt-4">
              <button
                onClick={e => sendRequest(e)}
                type="submit"
                className="px-10 pt-2.5 pb-2.5 text-lg font-medium text-center text-white bg-primary rounded-md w-full max-w-[300px] mx-auto"
              >
                Submit Request
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default FreeQuotesModal;
